module.exports = __webpack_public_path__ + "img/ie.31331e78.svg";